import React from "react";
function PlusSquare({className="", hideBorder=false}) {
  return (
    <svg
      className={`h-5 w-5 text-brand-base-primary ${className}`}
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      {!hideBorder && <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />}
      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
    </svg>
  );
}
export default PlusSquare;
